<div class="min-h-[calc(100vh-10rem)] flex items-center justify-center py-12 px-4">
  <div class="w-full max-w-lg bg-white border border-gray-200 rounded-2xl shadow-lg p-8">
    <div class="mb-6 text-center">
      <h1 class="text-2xl font-bold text-gray-900">Create your account</h1>
      <p class="text-gray-500 mt-1">Join Scholaris in less than a minute</p>
    </div>

    @if (error) {
      <div class="bg-yellow-50 border border-yellow-300 rounded-md p-3 mb-4 relative" role="alert">
        <p class="font-semibold text-yellow-800">Registration problem</p>
        <p class="text-yellow-700 text-sm">{{ errorMessage }}</p>
        <button
          type="button"
          (click)="vanishError()"
          class="absolute top-2 right-2 text-yellow-700 hover:text-yellow-900 font-bold"
          aria-label="Close"
        >
          x
        </button>
      </div>
    }

    @if (success) {
      <div class="bg-green-50 border border-green-300 rounded-md p-3 mb-4 relative" role="alert">
        <p class="font-semibold text-green-800">Registration successful</p>
        <p class="text-green-700 text-sm">{{ successMessage }}</p>
      </div>
    }

    <form [formGroup]="registerForm" (ngSubmit)="registerUser()" class="space-y-4">
      <div class="grid sm:grid-cols-2 gap-4">
        <div>
          <label for="firstName" class="block text-sm font-medium text-gray-700 mb-1"
            >First name</label
          >
          <input
            id="firstName"
            type="text"
            formControlName="firstName"
            placeholder="Jane"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          @if (submitted && registerForm.controls.firstName.errors?.required) {
            <small class="text-sm text-yellow-700">First name is required.</small>
          }
        </div>

        <div>
          <label for="lastName" class="block text-sm font-medium text-gray-700 mb-1"
            >Last name</label
          >
          <input
            id="lastName"
            type="text"
            formControlName="lastName"
            placeholder="Doe"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          @if (submitted && registerForm.controls.lastName.errors?.required) {
            <small class="text-sm text-yellow-700">Last name is required.</small>
          }
        </div>
      </div>

      <div>
        <label for="email" class="block text-sm font-medium text-gray-700 mb-1">Email</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          placeholder="jane@example.com"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        @if (submitted && registerForm.controls.email.errors?.required) {
          <small class="text-sm text-yellow-700">Email is required.</small>
        }
        @if (submitted && registerForm.controls.email.errors?.email) {
          <small class="text-sm text-yellow-700">Please enter a valid email address.</small>
        }
      </div>

      <div>
        <label for="affiliation" class="block text-sm font-medium text-gray-700 mb-1"
          >Affiliation (optional)</label
        >
        <input
          id="affiliation"
          type="text"
          formControlName="affiliation"
          placeholder="University, Company, Lab..."
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label for="password" class="block text-sm font-medium text-gray-700 mb-1">Password</label>
        <input
          id="password"
          type="password"
          formControlName="password"
          placeholder="At least 8 characters"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        @if (submitted && registerForm.controls.password.errors?.required) {
          <small class="text-sm text-yellow-700">Password is required.</small>
        }
        @if (submitted && registerForm.controls.password.errors?.minlength) {
          <small class="text-sm text-yellow-700">Password must be at least 8 characters.</small>
        }
      </div>

      <button
        type="submit"
        class="w-full py-2.5 bg-primary text-white font-semibold rounded-md hover:bg-blue-700 transition-colors"
      >
        Create account
      </button>
    </form>

    <p class="mt-5 text-sm text-center text-gray-600">
      Already registered?
      <a routerLink="/login" class="text-blue-600 hover:text-blue-700 font-semibold">Log in</a>
    </p>

    @if (showSuperAdminSetupLink) {
      <div class="text-center">
        <p class="mt-3 text-sm text-center text-gray-600">
          Setting up a new environment?
          <a routerLink="/admin/setup" class="text-blue-600 hover:text-blue-700 font-semibold"
            >Create Super Admin</a
          >
        </p>
      </div>
    }
  </div>
</div>
